export const BACKEND_MAIN_ERROR_CODES = {
  candidateNotLicensedForWorkerType: "candidateNotLicensedForWorkerType",
  shiftAssignedToAnotherWorker: "shiftAssignedToAnotherWorker",
};
